import { render } from "./Simulations.vue?vue&type=template&id=ef7653b4&scoped=true&ts=true"
import script from "./Simulations.vue?vue&type=script&lang=ts"
export * from "./Simulations.vue?vue&type=script&lang=ts"

import "./Simulations.vue?vue&type=style&index=0&id=ef7653b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7653b4"]])

export default __exports__